import React from 'react';
import CompanyEarningsWidgetRenderer from './CompanyEarningsWidgetRenderer';

const Preview: React.FC = () => (
  <CompanyEarningsWidgetRenderer config={{}} />
);

export default Preview;
